import React from 'react';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { buildPreloanPath } from '../utils/navigateToPreloan';
import AccountRoutes from './account';
import PreloanRoutes from './preloan';
import VerifyRoutes from './verify';
import BnplRoutes from './bnpl';
import NotFound from './404';
import ReferralTermsAndConditions from '../pages/referral-terms-and-conditions';
import TermsAndConditions from '../pages/terms-and-conditions';
import AuthorizationRoutes from './authorization';
import LoanPayment from '../pages/loan-payment';
import DataDeletionRoutes from './user-data-deletion';

const notFound = () => <NotFound />;

function AppRoutes() {
  return (
    <Route
      render={
        ({ location }) => (
          <Switch location={location}>
            <Route path="/preloan" component={PreloanRoutes} />
            <Route path="/account" component={AccountRoutes} />
            <Route path="/verify" component={VerifyRoutes} />
            <Route path="/bnpl" component={BnplRoutes} />
            <Route path="/referral-terms-and-conditions" component={ReferralTermsAndConditions} />
            <Route path="/terms-and-conditions" component={TermsAndConditions} />
            <Route path="/authorization" component={AuthorizationRoutes} />
            <Route path="/loan-payment" component={LoanPayment} />
            <Route path="/user-data-deletion" component={DataDeletionRoutes} />
            <Route path="/">
              <Redirect to={buildPreloanPath()} />
            </Route>
            <Route component={notFound} />
          </Switch>
        )
      }
    />
  );
}

export default AppRoutes;
